import { Box, Text } from "@chakra-ui/react";
import { Input, Select } from "antd";
import { useFormik } from "formik";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import ButtonCustom from "../../../../components/button/ButtonCustom";
import ButtonPrimary from "../../../../components/button/ButtonPrimary";
import CustomToggle from "../../../../components/customToggle/CustomToggle";
import DropDownCustom from "../../../../components/DropDownCustom";
import HeadTitle from "../../../../components/HeadTitle";
import { DeleteSuccess, SavedSuccess } from "../../../../components/icons";
import ModalCustom from "../../../../components/ModalCustom";
import ValidationError from "../../../../components/validationErrorMessage/ValidationError";
import { ID_CSM_MASTER } from "../../../../constant/idConstant";
import {
  GRAY_COLOR,
  PRIMARY_COLOR,
} from "../../../../constant/propertiesConstant";
import { ROUTES_USER_BUYER } from "../../../../constant/routeConstant";
import {
  selectPMHandling,
  selectStatus,
} from "../../../../constant/selectOptConstant";
import { inputTheme } from "../../../../constant/themeConstant";
import {
  getListCustomer,
  getListPrincipalDDS,
} from "../../../../services/main/customerReducer";
import { getListDistributor } from "../../../../services/main/distributorReducer";
import { getListMasterStore } from "../../../../services/main/masterStoreReducer";
import { getListNotification } from "../../../../services/main/notificationReducer";
import {
  addStoreSupplier,
  getListCustomerDDS,
  getListDistributorDDS,
  getListStoreDDS,
  getListWarehouseDDS,
} from "../../../../services/main/storeSupplierConnectionReducer";
import {
  getListPrincipal,
  getListWarehouse,
} from "../../../../services/main/warehouseReducer";
import StringUtil from "../../../../utils/stringUtil";
import { addSchema } from "./StoreSuppConnSchema";

const AddStoreSuppConn = () => {
  const { t } = useTranslation();
  const { Option } = Select;
  const dispatch = useDispatch();

  const history = useHistory();

  const [ischeckedPM, setIscheckedPM] = useState(true);
  const [ischeckedBKL, setIscheckedBKL] = useState(false);

  // customer
  const [dataCustomer, setDataCustomer] = useState([]);
  const [pageCustomer, setPageCustomer] = useState(1);
  const [limitCustomer] = useState(10);
  const [filterCustomerName, setfilterCustomerName] = useState("");
  const [idCustomer, setIdCustomer] = useState(null);

  // store
  const [dataStore, setDataStore] = useState([]);
  const [pageStore, setPageStore] = useState(1);
  const [limitStore] = useState(10);
  const [filterStoreName, setfilterStoreName] = useState("");
  const [idStore, setIdStore] = useState("");

  // notification
  const [dataNotification, setDataNotification] = useState([]);
  const [pageNotification, setPageNotification] = useState(1);
  const [limitNotification] = useState(10);
  const [filterNotificationName, setfilterNotificationName] = useState("");

  // notification
  const [dataNotificationFailed, setDataNotificationFailed] = useState([]);
  const [pageNotificationFailed, setPageNotificationFailed] = useState(1);
  const [limitNotificationFailed] = useState(10);
  const [filterNotificationNameFailed, setfilterNotificationNameFailed] =
    useState("");

  const [modalOpen, setModalOpen] = useState(false);
  const [response, setResponse] = useState("");
  const [err, setErr] = useState(false);

  // distributor
  const [pageDistributor, setPageDistributor] = useState(1);
  const [limitDistributor] = useState(10);
  const [filterDistributor, setFilterDistributor] = useState("");
  const [dataDistributor, setDataDistributor] = useState([]);
  const [idDistributor, setidDistributor] = useState(null);

  // warehouse
  const [dataWarehouse, setDataWarehouse] = useState([]);
  const [pageWarehouse, setPageWarehouse] = useState(1);
  const [limitWarehouse] = useState(10);
  const [filterWarehouseName, setfilterWarehouseName] = useState("");
  const [idWarehouse, setIdWarehouse] = useState(null);

  // variable principal
  const [pagePrincipal, setPagePrincipal] = useState(1);
  const [dataPrincipal, setDataPrincipal] = useState([]);
  const [limitPrincipal] = useState(10);
  const [filterPrincipalName, setFilterPrincipalName] = useState("");
  const [idPrincipal, setidPrincipal] = useState(null);

  const onSubmit = (values, action) => {
    delete values.salesman_code;
    delete values.salesman_name;
    dispatch(addStoreSupplier(values)).then((resp) => {
      if (resp.payload.ok) {
        setModalOpen(true);
        setResponse(resp.payload.response.nexsoft.payload.status.message);
        setErr(false);
        action.resetForm();
      } else {
        setModalOpen(true);
        setResponse(resp.payload.response.data.nexsoft.payload.status.message);
        setErr(true);
      }
    });
  };
  // Formik
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
      principal_id: "",
      customer_id: "",
      store_id: "",
      distributor_id: "",
      warehouse_id: null,
      supplier_code: "",
      principal_connection_store_id: "",
      is_bkl: "N",
      is_product_mapping: "Y",
      pm_handling: "",
      notification_id: null,
      notification_alert_id: null,
      status: "",
      farmindo_store: null,
      additional_data: {
        salesman_code: "",
        salesman_name: "",
      },
    },
    validationSchema: addSchema,
    onSubmit,
  });

  const fetchDistributor = () => {
    const page = pageDistributor;
    const limit = limitDistributor;
    const filter = StringUtil.formatFilter({
      distributor_name: `like ${filterDistributor}`,
      principal_id: `eq ${idPrincipal}`,
      status: `eq A`,
    });
    const params = { page, limit, filter };
    if (idPrincipal === null) {
      setDataDistributor("");
    } else {
      dispatch(getListDistributorDDS(params)).then((response) => {
        if (!response.payload.ok) return;
        const resp = response.payload.response;
        if (!resp) return;
        setDataDistributor([...dataDistributor, ...resp]);
      });
    }
  };
  const fetchDistributorSearch = () => {
    const page = pageDistributor;
    const limit = limitDistributor;
    const filter = StringUtil.formatFilter({
      distributor_name: `like ${filterDistributor}`,
      principal_id: `eq ${idPrincipal}`,
      status: `eq A`,
    });
    const params = { page, limit, filter };
    setDataDistributor("");
    dispatch(getListDistributorDDS(params)).then((response) => {
      if (!response.payload.ok) return;
      setPageDistributor(1);
      setDataDistributor(response.payload.response);
    });
  };
  useEffect(() => {
    fetchDistributor();
  }, [pageDistributor]);
  useEffect(() => {
    fetchDistributorSearch();
  }, [filterDistributor, idPrincipal]);

  const handleScrollDistributor = (event) => {
    setPageDistributor(pageDistributor + 1);
  };

  const dataDistributorCode = useMemo(() => {
    // find distributor code by selected distributor_id
    if (values.distributor_id) {
      return dataDistributor?.find((search) => search.id === idDistributor);
    }
  }, [idDistributor]);
  //   end parameter distributor

  // fungsi customer
  const handleScrollCustomer = (event) => {
    setPageCustomer(pageCustomer + 1);
  };

  const fetchCustomer = () => {
    const page = pageCustomer;
    const limit = limitCustomer;
    // const params = { page, limit };
    const filter = `customer_name like ${filterCustomerName}`;
    const params =
      filterCustomerName === "" ? { page, limit } : { page, limit, filter };
    dispatch(getListCustomerDDS(params)).then((response) => {
      if (!response.payload.ok) return;
      const resp = response.payload.response;
      if (!resp) return;
      setDataCustomer([...dataCustomer, ...resp]);
    });
  };
  const fetchCustomerSearch = () => {
    const page = pageCustomer;
    const limit = limitCustomer;
    const filter = `customer_name like ${filterCustomerName}`;
    const params =
      filterCustomerName === "" ? { page, limit } : { page, limit, filter };
    dispatch(getListCustomerDDS(params)).then((response) => {
      if (response.payload.ok) {
        setPageCustomer(1);
        setDataCustomer(response.payload.response);
      }
    });
  };

  useEffect(() => {
    fetchCustomer();
  }, [pageCustomer]);
  useEffect(() => {
    fetchCustomerSearch();
  }, [filterCustomerName]);

  const dataCustomerCode = useMemo(() => {
    // find customer code by selected customer id
    return dataCustomer?.find((search) => search.id === idCustomer);
  }, [idCustomer]);
  // end fungsi customer

  // fungsi warehouse
  const handleScrollWarehouse = (event) => {
    setPageCustomer(pageWarehouse + 1);
  };

  const fetchWarehouse = () => {
    const page = pageWarehouse;
    const limit = limitWarehouse;
    const filter = StringUtil.formatFilter({
      warehouse_name: `like ${filterWarehouseName}`,
    });
    const params = { page, limit, filter };
    dispatch(getListWarehouseDDS(params)).then((response) => {
      if (!response.payload.ok) return;
      const resp = response.payload.response;
      if (!resp) return;
      setDataWarehouse([...dataWarehouse, ...resp]);
    });
  };
  const fetchWarehouseSearch = () => {
    const page = pageWarehouse;
    const limit = limitWarehouse;
    const filter = StringUtil.formatFilter({
      warehouse_name: `like ${filterWarehouseName}`,
    });
    const params =
      filterWarehouseName === "" ? { page, limit } : { page, limit, filter };
    dispatch(getListWarehouseDDS(params)).then((response) => {
      if (response.payload.ok) {
        setPageWarehouse(1);
        setDataWarehouse(response.payload.response);
      }
    });
  };

  useEffect(() => {
    fetchWarehouse();
  }, [pageWarehouse]);
  useEffect(() => {
    fetchWarehouseSearch();
  }, [filterWarehouseName]);

  const dataWarehouseName = useMemo(() => {
    // find customer code by selected customer id
    return dataWarehouse?.find((search) => search.id === idWarehouse);
  }, [idWarehouse]);
  // end fungsi warehouse

  // fungsi store
  const fetchStore = () => {
    const page = pageStore;
    const limit = limitStore;
    const filter = StringUtil.formatFilter({
      store_name: `like ${filterStoreName}`,
      customer_id: `eq ${idCustomer}`,
    });
    const params =
      idCustomer === null ? { page, limit } : { page, limit, filter };
    if (idCustomer === null) {
      setDataStore("");
    } else {
      dispatch(getListMasterStore(params)).then((response) => {
        if (!response.payload.ok) return;
        const resp = response.payload.response;
        if (!resp) return;
        setDataStore([...dataStore, ...resp]);
      });
    }
  };
  // ketika id Customer diganti, list store di fetch ulang (data diganti sesuai id customer yang baru)
  const fetchStoreCustomer = () => {
    const page = pageStore;
    const limit = limitStore;
    const filter = StringUtil.formatFilter({
      store_name: `like ${filterStoreName}`,
      customer_id: `eq ${idCustomer}`,
    });
    const params =
      idCustomer === null ? { page, limit } : { page, limit, filter };
    if (idCustomer === null) {
      setDataStore("");
    } else {
      dispatch(getListMasterStore(params)).then((response) => {
        if (!response.payload.ok) return;
        setDataStore("");
        setPageStore(1);
        setDataStore(response.payload.response);
      });
    }
  };
  const fetchStoreSearch = () => {
    const page = pageStore;
    const limit = limitStore;
    const filter = StringUtil.formatFilter({
     "store_name||store_code" : `like ${filterStoreName}`,
      customer_id: `eq ${idCustomer}`,
    });
    const params =
      filterStoreName === "" ? { page, limit } : { page, limit, filter };
    if (idCustomer === null) {
      setDataStore("");
    } else {
      dispatch(getListStoreDDS(params)).then((response) => {
        if (!response.payload.ok) return;
        setPageStore(1);
        setDataStore(response.payload.response);
      });
    }
  };

  useEffect(() => {
    fetchStore();
  }, [pageStore]);
  useEffect(() => {
    fetchStoreCustomer();
  }, [idCustomer]);
  useEffect(() => {
    fetchStoreSearch();
  }, [filterStoreName]);

  const handleScrollStore = (event) => {
    setPageStore(pageStore + 1);
  };

  const detailStoreData = useMemo(() => {
    // find detail data store from selected idStore
    if (dataStore.length > 1) {
      return dataStore?.find((search) => search.id === idStore);
    }
  }, [idStore]);

  // end fungsi store

  // start fungsi principal
  const fetchPrincipal = () => {
    const page = pagePrincipal;
    const limit = limitPrincipal;
    const params = { page, limit };
    dispatch(getListPrincipalDDS(params)).then((response) => {
      if (!response.payload.ok) return;
      const resp = response.payload.response;
      if (!resp) return;
      setDataPrincipal([...dataPrincipal, ...resp]);
    });
  };
  const fetchPrincipalSearch = () => {
    const page = pagePrincipal;
    const limit = limitPrincipal;
    const filter = `name like ${filterPrincipalName}`;
    const params =
      filterPrincipalName === "" ? { page, limit } : { page, limit, filter };

    dispatch(getListPrincipalDDS(params)).then((response) => {
      if (!response.payload.ok) return;
      setPagePrincipal(1);
      setDataPrincipal(response.payload.response);
    });
  };
  useEffect(() => {
    fetchPrincipal();
  }, [pagePrincipal]);
  useEffect(() => {
    fetchPrincipalSearch();
  }, [filterPrincipalName]);

  const handleScrollPrincipal = (event) => {
    setPagePrincipal(pagePrincipal + 1);
  };
  // end fungsi principal

  // start fungsi notification
  const fetchNotification = () => {
    const page = pageNotification;
    const limit = limitNotification;
    const filter = StringUtil.formatFilter({
      name: `like ${filterNotificationName}`,
      principal_id: `eq ${idPrincipal}`,
      category: `eq SUCCESS`,
    });
    const params = { page, limit, filter };
    dispatch(getListNotification(params)).then((response) => {
      if (!response.payload.ok) return;
      const resp = response.payload.response;
      if (!resp) return;
      setDataNotification([...dataNotification, ...resp]);
    });
  };
  const fetchNotificationSearch = () => {
    const page = pageNotification;
    const limit = limitNotification;
    const filter = StringUtil.formatFilter({
      name: `like ${filterNotificationName}`,
      principal_id: `eq ${idPrincipal}`,
      category: `eq SUCCESS`,
    });
    const params = { page, limit, filter };

    dispatch(getListNotification(params)).then((response) => {
      if (!response.payload.ok) return;
      setPageNotification(1);
      setDataNotification(response.payload.response);
    });
  };
  useEffect(() => {
    fetchNotification();
  }, [pageNotification]);
  useEffect(() => {
    fetchNotificationSearch();
  }, [filterNotificationName, idPrincipal]);

  const handleScrollNotification = (event) => {
    setPageNotification(pageNotification + 1);
  };
  // end fungsi notification

  // start fungsi notification
  const fetchNotificationFailed = () => {
    const page = pageNotificationFailed;
    const limit = limitNotificationFailed;
    const filter = StringUtil.formatFilter({
      name: `like ${filterNotificationNameFailed}`,
      principal_id: `eq ${idPrincipal}`,
      category: `eq FAILED`,
    });
    const params = { page, limit, filter };
    dispatch(getListNotification(params)).then((response) => {
      if (!response.payload.ok) return;
      const resp = response.payload.response;
      if (!resp) return;
      setDataNotificationFailed([...dataNotificationFailed, ...resp]);
    });
  };
  const fetchNotificationSearchFailed = () => {
    const page = pageNotificationFailed;
    const limit = limitNotificationFailed;
    const filter = StringUtil.formatFilter({
      name: `like ${filterNotificationNameFailed}`,
      principal_id: `eq ${idPrincipal}`,
      category: `eq FAILED`,
    });
    const params = { page, limit, filter };

    dispatch(getListNotification(params)).then((response) => {
      if (!response.payload.ok) return;
      setPageNotificationFailed(1);
      setDataNotificationFailed(response.payload.response);
    });
  };
  useEffect(() => {
    fetchNotificationFailed();
  }, [pageNotificationFailed]);
  useEffect(() => {
    fetchNotificationSearchFailed();
  }, [filterNotificationNameFailed, idPrincipal]);

  const handleScrollNotificationFailed = (event) => {
    setPageNotificationFailed(pageNotificationFailed + 1);
  };
  // end fungsi notification

  const handleChangeSelect = (name, value, option) => {
    if (name === "distributor_id") {
      setFieldValue("distributor_id", value);
      setidDistributor(value);
    } else if (name === "principal_id") {
      setFieldValue("principal_id", value);
      setidPrincipal(value);
      setFieldValue("distributor_id", null);
      setFieldValue("notification_id", null);
      setFieldValue("notification_alert_id", null);
    } else if (name === "customer_id") {
      setFieldValue("customer_id", value);
      setIdCustomer(value);
    } else if (name === "store_id") {
      setFieldValue("store_id", value);
      setIdStore(value);
    } else if (name === "warehouse_id") {
      setFieldValue("warehouse_id", value);
      setIdWarehouse(value);
    }
    setFieldValue(name, value);
  };

  // modal success or failed
  const modalSuccess = () => {
    history.push(ROUTES_USER_BUYER.STORE_SUPPLIER_CONNECTION.LIST);
  };
  const modalFailed = () => {
    setModalOpen(false);
  };

  const regexFormatter = (onChangeCallback, regex) => {
    return (event) => {
      const value = event.target.value?.replace(regex, "");
      onChangeCallback(value, event.target.name);
    };
  };
  const renderCustomForm = () => {
    // kao = 2 , nestle = 8 kid= 19
    if (
      values.principal_id === 2 ||
      values.principal_id === 8 ||
      values.principal_id === 19
    ) {
      return (
        <>
          {/* salesman code */}
          <Box padding={1} display="flex">
            <Box width="10rem" pl={2}>
              <Text>
                {t("STORE_SUPPLIER_CONNECTION:FIELD_SALESMAN_CODE")}{" "}
                {t("STORE_SUPPLIER_CONNECTION:OPTIONAL")}
              </Text>
            </Box>
            <Box className="form-input-padding-bottom">
              <Input
                name="salesman_code"
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue(
                    "additional_data.salesman_code",
                    e.currentTarget.value
                  );
                }}
                style={inputTheme}
                type="text"
                width="12rem"
                onBlur={handleBlur}
                id={ID_CSM_MASTER.ADD.ADDITIONAL_SALESMAN_CODE}
              />
              {errors.salesman_code && touched.salesman_code && (
                <ValidationError text={errors.salesman_code} />
              )}
            </Box>
          </Box>

          {/* salesman name */}
          <Box padding={1} display="flex">
            <Box width="10rem" pl={2}>
              <Text>
                {t("STORE_SUPPLIER_CONNECTION:FIELD_SALESMAN_NAME")}{" "}
                {t("STORE_SUPPLIER_CONNECTION:OPTIONAL")}
              </Text>
            </Box>
            <Box className="my-select-container" pb={1}>
              <Input
                name="salesman_name"
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue(
                    "additional_data.salesman_name",
                    e.currentTarget.value
                  );
                }}
                style={inputTheme}
                type="text"
                width="12rem"
                onBlur={handleBlur}
                id={ID_CSM_MASTER.ADD.ADDITIONAL_SALESMAN_NAME}
              />
              {errors.salesman_name && (
                <ValidationError text={errors.salesman_name} />
              )}
            </Box>
          </Box>
        </>
      );
    }
  };
  const renderCustomNestle = () => {
    if (values.principal_id === 8) {
      return (
        <>
          {/* warehouse id */}
          <Box padding={1} display="flex">
            <Box width="10rem" pl={2}>
              <Text>
                {t("STORE_SUPPLIER_CONNECTION:FIELD_WAREHOUSE_NAME")}{" "}
                {t("STORE_SUPPLIER_CONNECTION:OPTIONAL")}
              </Text>
            </Box>
            <Box className="my-select-container" pb={1}>
              <Select
                id={ID_CSM_MASTER.ADD.WAREHOUSE_NAME}
                style={inputTheme}
                size="large"
                name="warehouse_id"
                onPopupScroll={handleScrollWarehouse}
                onChange={(value, opt) =>
                  handleChangeSelect("warehouse_id", value, opt)
                }
                dropdownRender={(menu) => (
                  <DropDownCustom
                    menu={menu}
                    search={(e) => setfilterWarehouseName(e.target.value)}
                  />
                )}
                showSearch={false}
                allowClear="true"
              >
                {dataWarehouse &&
                  dataWarehouse.map((data, index) => {
                    return (
                      <Select.Option
                        key={index}
                        value={data.id}
                        title={data.warehouse_name}
                      >
                        {data.warehouse_name}
                      </Select.Option>
                    );
                  })}
              </Select>
              {errors.warehouse_id && touched.warehouse_id && (
                <ValidationError text={errors.warehouse_id} />
              )}
            </Box>
          </Box>
          {/* warehouse name */}
          <Box padding={1} display="flex">
            <Box width="10rem" pl={2}>
              <Text>
                {t("STORE_SUPPLIER_CONNECTION:FIELD_WAREHOUSE_CODE")}{" "}
              </Text>
              <Text>{t("STORE_SUPPLIER_CONNECTION:OPTIONAL")}</Text>
            </Box>
            <Box pb={1}>
              <Input
                disabled
                name="barcode"
                value={
                  dataWarehouseName ? dataWarehouseName.warehouse_code : ""
                }
                style={inputTheme}
                type="text"
                id={ID_CSM_MASTER.ADD.WAREHOUSE_CODE}
              />
            </Box>
          </Box>
        </>
      );
    }
  };
  const handleSwitchChange = (event) => {
    const valuePM = !ischeckedPM;
    setFieldValue("is_product_mapping", valuePM === true ? "Y" : "N");
    setIscheckedPM(!ischeckedPM);
  };
  const handleSwitchBKLChange = (event) => {
    const valueBKL = !ischeckedBKL;
    setFieldValue("is_bkl", valueBKL === true ? "Y" : "N");
    setIscheckedBKL(!ischeckedBKL);
  };

  const setFarmindoStore = useMemo(() => {
    setFieldValue("farmindo_store", detailStoreData?.store_alias);
  }, [detailStoreData]);

  useMemo(() => {
    setIdWarehouse(null);
    setFieldValue("warehouse_id", null);
    setFieldValue("additional_data.salesman_name", "");
    setFieldValue("additional_data.salesman_code", "");
  }, [idDistributor]);
  return (
    <Box padding={4}>
      <HeadTitle
        title={t("STORE_SUPPLIER_CONNECTION:ADD_STORE")}
        subtitle={
          <>
            <span style={{ color: PRIMARY_COLOR }}>
              {t("STORE_SUPPLIER_CONNECTION:SUBTITLE_1")}
            </span>{" "}
            -{" "}
            <span style={{ color: PRIMARY_COLOR }}>
              {t("STORE_SUPPLIER_CONNECTION:SUBTITLE_3")}
            </span>{" "}
            -{" "}
            <span style={{ color: PRIMARY_COLOR }}>
              {t("STORE_SUPPLIER_CONNECTION:TITLE_LIST")}
            </span>{" "}
            - {t("STORE_SUPPLIER_CONNECTION:SUBTITLE_4")}
          </>
        }
      />
      {/* white box  */}
      <form onSubmit={handleSubmit}>
        <Box
          backgroundColor="white"
          minHeight="300px"
          padding={4}
          // justifyContent="space-between"
          display="flex"
          flex-direction="column"
          align-items="flex-end"
          gap="20px"
          marginTop={4}
          borderRadius={10}
        >
          {/* left side */}
          <Box
            padding={1}
            width="402px"
            flexDirection="column"
            alignItems="flex-start"
          >
            {/* supplier code */}
            <Box
              padding={1}
              width="402px"
              display="flex"
              flexDirection="row"
              alignItems="center"
              gap="28px"
            >
              <Box className="form-title">
                <Text width="92px">
                  {t("STORE_SUPPLIER_CONNECTION:FIELD_SUPPLIER_CODE")}
                </Text>
              </Box>
              <Box className="form-input-padding-bottom">
                <Input
                  name="supplier_code"
                  value={values.supplier_code}
                  style={inputTheme}
                  onChange={handleChange}
                  type="text"
                  width="12rem"
                  backgroundColor={GRAY_COLOR}
                  id={ID_CSM_MASTER.ADD.SUPPLIER_CODE}
                />
                {errors.supplier_code && touched.supplier_code && (
                  <ValidationError text={errors.supplier_code} />
                )}
              </Box>
            </Box>
            {/* distributor Code */}
            <Box padding={1} display="flex">
              <Box width="10rem" className="form-title">
                <Text overflowWrap="break-word" width="120px">
                  {t("STORE_SUPPLIER_CONNECTION:FIELD_DISTRIBUTOR_CODE")}
                </Text>
              </Box>
              <Box className="form-input-padding-bottom">
                <Input
                  disabled
                  name="distributor_code"
                  //   get data from dropdown distributor name
                  value={
                    values.distributor_id
                      ? dataDistributorCode.distributor_code
                      : ""
                  }
                  style={inputTheme}
                  type="text"
                  width="12rem"
                  id={ID_CSM_MASTER.ADD.DISTRIBUTOR_CODE}
                />
              </Box>
            </Box>
            {/* customer code*/}
            <Box padding={1} display="flex">
              <Box width="10rem" className="form-title">
                <Text>
                  {t("STORE_SUPPLIER_CONNECTION:FIELD_CUSTOMER_CODE")}
                </Text>
              </Box>
              <Box className="form-input-padding-bottom">
                <Input
                  disabled
                  name="barcode"
                  value={dataCustomerCode ? dataCustomerCode.customer_code : ""}
                  style={inputTheme}
                  type="text"
                  id={ID_CSM_MASTER.ADD.CUSTOMER_CODE}
                />
              </Box>
            </Box>

            {/* store id */}
            <Box padding={1} display="flex">
              <Box width="10rem" className="form-title">
                <Text>{t("STORE_SUPPLIER_CONNECTION:FIELD_STORE_CODE")}</Text>
              </Box>
              <Box className="form-input-padding-bottom">
                <Input
                  disabled
                  value={detailStoreData?.store_code}
                  name="store_id"
                  style={inputTheme}
                  onBlur={handleBlur}
                  id={ID_CSM_MASTER.ADD.STORE_ID}
                />
              </Box>
            </Box>

            {/* alias */}
            <Box padding={1} display="flex">
              <Box width="10rem" className="form-title">
                <Text overflowWrap="break-word" width="120px">
                  {t("STORE_SUPPLIER_CONNECTION:FIELD_ALIAS")}
                </Text>
              </Box>
              <Box className="form-input-padding-bottom">
                <Input
                  value={values.principal_connection_store_id}
                  name="principal_connection_store_id"
                  onChange={handleChange}
                  style={inputTheme}
                  type="text"
                  width="12rem"
                  onBlur={handleBlur}
                  id={ID_CSM_MASTER.ADD.ALIAS}
                />
                {errors.principal_connection_store_id &&
                  touched.principal_connection_store_id && (
                    <ValidationError
                      text={errors.principal_connection_store_id}
                    />
                  )}
              </Box>
            </Box>
            {/* pm handling */}
            <Box padding={1} display="flex">
              <Box width="10rem" className="form-title">
                <Text>{t("STORE_SUPPLIER_CONNECTION:FIELD_PM_HANDLING")}</Text>
              </Box>
              <Box className="my-select-container" pb={1}>
                <Select
                  id={ID_CSM_MASTER.ADD.PM_HANDLING}
                  style={inputTheme}
                  size="large"
                  value={values.pm_handling}
                  onChange={(value, opt) =>
                    handleChangeSelect("pm_handling", value, opt)
                  }
                  showSearch={false}
                  allowClear="true"
                >
                  {selectPMHandling?.map((value, index) => {
                    return (
                      <Option key={index} value={value.value}>
                        {t(value.label)}
                      </Option>
                    );
                  })}
                </Select>
                {errors.pm_handling && touched.pm_handling && (
                  <ValidationError text={errors.pm_handling} />
                )}
              </Box>
            </Box>
            {/* notification name */}
            <Box padding={1} display="flex">
              <Box width="10rem" pl={2}>
                <Text>
                  {t("STORE_SUPPLIER_CONNECTION:FIELD_NOTIFICATION_NAME")}{" "}
                  {t("STORE_SUPPLIER_CONNECTION:OPTIONAL")}
                </Text>
              </Box>
              <Box className="my-select-container" pb={1}>
                <Select
                  id={ID_CSM_MASTER.ADD.NOTIFICATION_NAME}
                  disabled={!values.principal_id}
                  style={inputTheme}
                  size="large"
                  value={values.notification_id}
                  onPopupScroll={handleScrollNotification}
                  onChange={(value, opt) =>
                    handleChangeSelect("notification_id", value, opt)
                  }
                  dropdownRender={(menu) => (
                    <DropDownCustom
                      menu={menu}
                      search={(e) => setfilterNotificationName(e.target.value)}
                    />
                  )}
                  showSearch={false}
                  allowClear="true"
                >
                  {dataNotification &&
                    dataNotification.map((data, index) => {
                      return (
                        <Select.Option
                          key={index}
                          value={data.id}
                          title={data.name}
                        >
                          {data.name}
                        </Select.Option>
                      );
                    })}
                </Select>
              </Box>
            </Box>
            {/* alert */}
            <Box padding={1} display="flex">
              <Box width="10rem" className="form-title">
                <Text>
                  {t("STORE_SUPPLIER_CONNECTION:FIELD_ALERT")}{" "}
                  {t("STORE_SUPPLIER_CONNECTION:OPTIONAL")}
                </Text>
              </Box>
              <Box className="my-select-container" pb={1}>
                <Select
                  id={ID_CSM_MASTER.ADD.ALERT}
                  disabled={!values.principal_id}
                  style={inputTheme}
                  size="large"
                  value={values.notification_alert_id}
                  onPopupScroll={handleScrollNotificationFailed}
                  onChange={(value, opt) =>
                    handleChangeSelect("notification_alert_id", value, opt)
                  }
                  dropdownRender={(menu) => (
                    <DropDownCustom
                      menu={menu}
                      search={(e) =>
                        setfilterNotificationNameFailed(e.target.value)
                      }
                    />
                  )}
                  showSearch={false}
                  allowClear="true"
                >
                  {dataNotificationFailed &&
                    dataNotificationFailed.map((data, index) => {
                      return (
                        <Select.Option
                          key={index}
                          value={data.id}
                          title={data.name}
                        >
                          {data.name}
                        </Select.Option>
                      );
                    })}
                </Select>
              </Box>
            </Box>
            {/* status */}
            <Box padding={1} display="flex">
              <Box width="10rem" className="form-title">
                <Text>{t("STORE_SUPPLIER_CONNECTION:FIELD_STATUS")}</Text>
              </Box>
              <Box className="my-select-container">
                <Select
                  id={ID_CSM_MASTER.ADD.STATUS}
                  style={inputTheme}
                  size="large"
                  value={values.status}
                  onChange={(value, opt) =>
                    handleChangeSelect("status", value, opt)
                  }
                  showSearch={false}
                  allowClear="true"
                >
                  {selectStatus?.map((value, index) => {
                    return (
                      <Option key={index} value={value.value}>
                        {t(value.label)}
                      </Option>
                    );
                  })}
                </Select>
                {errors.status && touched.status && (
                  <ValidationError text={errors.status} />
                )}
              </Box>
            </Box>
          </Box>
          {/* end of left side  */}

          {/* right side */}
          <Box padding={1} marginRight={8}>
            <Box padding={1} display="flex">
              <Box width="10rem" className="form-title">
                <Text>
                  {t("STORE_SUPPLIER_CONNECTION:FIELD_PRINCIPAL_NAME")}
                </Text>
              </Box>
              <Box className="my-select-container">
                <Select
                  id={ID_CSM_MASTER.ADD.PRINCIPAL_NAME}
                  style={inputTheme}
                  value={values.principal_id}
                  onPopupScroll={handleScrollPrincipal}
                  onChange={(value, opt) =>
                    handleChangeSelect("principal_id", value, opt)
                  }
                  dropdownRender={(menu) => (
                    <DropDownCustom
                      value={filterPrincipalName}
                      menu={menu}
                      search={(e) => setFilterPrincipalName(e.target.value)}
                    />
                  )}
                  allowClear="true"
                  showSearch={false}
                  size="large"
                >
                  {dataPrincipal &&
                    dataPrincipal.map((data, index) => {
                      return (
                        <Select.Option key={index} value={data.id}>
                          {data.company_profile_name}
                        </Select.Option>
                      );
                    })}
                </Select>
              </Box>
            </Box>
            {/* distributor name */}
            <Box padding={1} display="flex">
              <Box width="10rem" className="form-title">
                <Text>
                  {t("STORE_SUPPLIER_CONNECTION:FIELD_DISTRIBUTOR_NAME")}
                </Text>
              </Box>
              <Box className="my-select-container">
                <Select
                  id={ID_CSM_MASTER.ADD.DISTRIBUTOR_NAME}
                  style={inputTheme}
                  disabled={!values?.principal_id}
                  value={values.distributor_id}
                  onPopupScroll={handleScrollDistributor}
                  // menggunakan onchange
                  onChange={(value, opt) =>
                    handleChangeSelect("distributor_id", value, opt)
                  }
                  dropdownRender={(menu) => (
                    <DropDownCustom
                      menu={menu}
                      search={(e) => setFilterDistributor(e.target.value)}
                    />
                  )}
                  showSearch={false}
                  allowClear="true"
                  size="large"
                >
                  {dataDistributor &&
                    dataDistributor.map((data, index) => {
                      return (
                        <Select.Option
                          key={index}
                          value={data.id}
                          title={data.name}
                        >
                          {data.name}
                        </Select.Option>
                      );
                    })}
                </Select>
                {errors.distributor_id && touched.distributor_id && (
                  <ValidationError text={errors.distributor_id} />
                )}
              </Box>
            </Box>
            {renderCustomForm()}
            {renderCustomNestle()}
            {/* customer name */}
            <Box padding={1} display="flex">
              <Box width="10rem" className="form-title">
                <Text>
                  {t("STORE_SUPPLIER_CONNECTION:FIELD_CUSTOMER_NAME")}
                </Text>
              </Box>
              <Box className="my-select-container" pb={1}>
                <Select
                  id={ID_CSM_MASTER.ADD.CUSTOMER_NAME}
                  style={inputTheme}
                  size="large"
                  value={values.customer_id}
                  onPopupScroll={handleScrollCustomer}
                  // menggunakan onchange
                  onChange={(value, opt) =>
                    handleChangeSelect("customer_id", value, opt)
                  }
                  dropdownRender={(menu) => (
                    <DropDownCustom
                      menu={menu}
                      search={(e) => setfilterCustomerName(e.target.value)}
                    />
                  )}
                  showSearch={false}
                  allowClear="true"
                >
                  {dataCustomer &&
                    dataCustomer.map((data, index) => {
                      return (
                        <Select.Option
                          key={index}
                          value={data.id}
                          title={data.name}
                        >
                          {data.name}
                        </Select.Option>
                      );
                    })}
                </Select>
                {errors.customer_id && touched.customer_id && (
                  <ValidationError text={errors.customer_id} />
                )}
              </Box>
            </Box>
            {/* store name */}
            <Box padding={1} display="flex">
              <Box width="10rem" className="form-title">
                <Text>{t("STORE_SUPPLIER_CONNECTION:FIELD_STORE_NAME")}</Text>
              </Box>
              <Box className="my-select-container" pb={1}>
                <Select
                  id={ID_CSM_MASTER.ADD.STORE_NAME}
                  style={inputTheme}
                  disabled={!values.customer_id}
                  size="large"
                  value={values.store_id}
                  onPopupScroll={handleScrollStore}
                  // menggunakan onchange
                  onChange={(value, opt) =>
                    handleChangeSelect("store_id", value, opt)
                  }
                  dropdownRender={(menu) => (
                    <DropDownCustom
                      menu={menu}
                      search={(e) => setfilterStoreName(e.target.value)}
                    />
                  )}
                  showSearch={false}
                  allowClear="true"
                >
                  {dataStore &&
                    dataStore.map((data, index) => {
                      return (
                        <Select.Option
                          key={index}
                          value={data.id}
                          title={data.store_name+ " - " + data.store_code }
                        >
                          {data.store_name + " - " + data.store_code}
                        </Select.Option>
                      );
                    })}
                </Select>
                {errors.store_id && touched.store_id && (
                  <ValidationError text={errors.store_id} />
                )}
              </Box>
            </Box>

            {/* BKL */}
            <Box padding={1} display="flex">
              <Box width="10rem" className="form-title">
                <Text>
                  {t("STORE_SUPPLIER_CONNECTION:FIELD_PRODUCT_MAPPING")}
                </Text>
              </Box>
              <Box className="form-input-padding-bottom">
                <CustomToggle
                  id={ID_CSM_MASTER.ADD.PRODUCT_MAPPING}
                  onChange={handleSwitchChange}
                  textChecked={t("COMMON:YES")}
                  textUnChecked={t("COMMON:NO")}
                  isChecked={ischeckedPM}
                />
              </Box>
            </Box>

            {/* BKL */}
            <Box padding={1} display="flex">
              <Box width="10rem" className="form-title">
                <Text>{t("STORE_SUPPLIER_CONNECTION:FIELD_BKL")}</Text>
              </Box>
              <Box className="form-input-padding-bottom">
                <CustomToggle
                  id={ID_CSM_MASTER.ADD.BKL}
                  onChange={handleSwitchBKLChange}
                  textChecked={t("COMMON:YES")}
                  textUnChecked={t("COMMON:NO")}
                  isChecked={ischeckedBKL}
                />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box display="flex" marginTop={4} float="right" paddingBottom={4}>
          <ButtonCustom
            colorScheme="blue"
            variant="outline"
            marginRight={2}
            width="9.375rem"
            link={ROUTES_USER_BUYER.STORE_SUPPLIER_CONNECTION.LIST}
            text={t("COMMON:BUTTON_CANCEL")}
            id={ID_CSM_MASTER.ADD.BTN_CANCEL}
          />
          <ButtonPrimary
            text={t("COMMON:BUTTON_SAVE")}
            width="9.375rem"
            type="submit"
            id={ID_CSM_MASTER.ADD.BTN_SAVE}
          />
        </Box>
        <ModalCustom
          message={response}
          isOpen={modalOpen}
          onOk={err ? modalFailed : modalSuccess}
          icon={err ? <DeleteSuccess /> : <SavedSuccess />}
        />
      </form>
    </Box>
  );
};

export default AddStoreSuppConn;
